const membership = [
    {
        name: 'Swimming',
        hourly: false,
        description: 'Don’t be afraid to dive in, you will find what real happiness means, once you get down deep here! be it a pool or in life.',
        image: 'swimming.jpg',
        imageFormat: 'jpg',
        content: `The ancient history of swimming does not tell us about a particular date or time of origin for the sport. Cave paintings suggest that prehistoric man was aware of swimming. The art of swimming has made a long journey and is being one of the most popular sports across the globe. Swimming is one of the most delightful & wonderful combinations of fun & fitness. Swimming is a healthy activity that you can continue for a lifetime. It is a low-impact activity that has immense physical as well as mental benefits.

            Hyderabadi’s couldn’t ignore to swim, whether it is an extremely sunny or chilled day, due to the sultry temperature and dreadful blanket of pollution the city holds, this mandates the residents of the city to have a good relishing swim session that helps to rejuvenate mental & physical fitness. Apart from this, swimming has been proved to have a numerous number of health benefits throughout the year whether it is extremely humid or cool as well.

            Therefore, we give the residents of the city the best spot for a pleasant swimming experience by providing the pool with international standards such as filters, salt chlorinators, underwater lights, cleaning accessories and many more. Moreover, we possess expertise professionals to monitor and train the beginners to assure the safety of the client.

            <strong>Why swim?</strong>
            &bull; It is a full-body workout
            &bull; Building cardiovascular strength
            &bull; Helps with asthma
            &bull; Safe during pregnancy
            &bull; Helping to improve sleep
            &bull; Boost mood by a spike in serotonin level
            &bull; Manage stress
            &bull; Improving symptoms of multiple sclerosis (MS)
            &bull; Good for people with injuries such as arthritis
            &bull; An excellent choice for people with disabilities`,
        plans: [
            {
                name: 'Individual',
                price: {
                    monthly: 2500,
                    quarterly: 6750,
                    halfYearly: 15000,
                    annual: 30000
                }
            },
            {
                name: 'Couple',
                price: {
                    monthly: 15194.30,
                    quarterly: 37985.75,
                    halfYearly: 76047.47,
                    annual: 136748.70
                }
            },
            {
                name: 'Family',
                price: {
                    monthly: 15194.30,
                    quarterly: 37985.75,
                    halfYearly: 84404.34,
                    annual: 136748.70
                }
            }
        ]
    },
    {
        name: 'Badminton',
        hourly: false,
        description: 'Want to know how to smash all the tough hurdles with full of a gush of wind in life? We have the best answer for this “Badminton”.',
        image: 'shuttle.jpg',
        imageFormat: 'jpg',
        content: `Hyderabad has been on the buzz when it is badminton! The glory is due to the legacy of the rise in ace sportspersons from this very same city such as Saina Nehwal, Srikanth Kidambi, jwala gutta, P.V. Sindhu and many more. This developed a passion & love among the citizens towards badminton. Hyderabad being extremely crowded runs out of the place and proper amenities that suit the sport, which we promise to fix with the best.

            At Urban Sports, we provide you indoor badminton courts that have no effect from the outdoor conditions, that will help you stick to the courts around the year. The courts provided are promised to be of international standardization’s such as equipment, training, and a wonderful infrastructure & facilities. Our coaching professionals will help you with everything, right from racquet orientation to choosing the perfect gear to play in.

            Badminton as a sports activity is a great way to keep fit due to the intense & terrific cardio-vascular exercise. It’s relatively inexpensive and is great leisure & recreational activity catering to all ages. The stack of tremendous health benefits include:
            &bull; Optimum heart health
            &bull; Control on diabetes
            &bull; Curbs hypertension
            &bull; Improved Lung Function
            &bull; Improves strength, flexibility, stamina, and Productivity
            &bull; Increases rate of metabolism
            &bull; Sharpens the mind`,
        plans: [
            {
                name: 'Individual',
                price: {
                    monthly: 3000,
                    quarterly: 8100,
                    halfYearly: 18000,
                    annual: 36000
                }
            },
            {
                name: 'Couple',
                price: {
                    monthly: 15194.30,
                    quarterly: 37985.75,
                    halfYearly: 76047.47,
                    annual: 136748.70
                }
            },
            {
                name: 'Family',
                price: {
                    monthly: 15194.30,
                    quarterly: 37985.75,
                    halfYearly: 84404.34,
                    annual: 136748.70
                }
            }
        ]
    },
    {
        name: 'Futsal',
        hourly: false,
        description: 'Remember one of the rules of life, you can learn all about life with a ball at your feet. Don’t you? you will, once you are here with us.',
        image: 'futsal.jpg',
        imageFormat: 'jpg',
        content: `Futsal is a variant of association football played on a hard court, smaller than a football pitch, and mainly indoors. Futsal is played between two teams of five players each, one of whom is the goalkeeper. The main emphasis of the game is on “improvisation, creativity, and technique.”

            The sport of futsal is taking the country by storm, especially in metros like Hyderabad, where getting the young generation involved in sports itself is a challenge, just because the sport becomes very interesting because of the small ground that keeps on moving the scoreboard making it short and crisp. Futsal brings up two crucial factors that play into the hands of people in metros – Small spaces and five-a-side. When you hear out to a football player’s heart, we will find the echo of a waving flag still running. That’s the measure of love the sport has.

            We present you the best standard futsal/ indoor football court for all the football lovers out there. So, no wait! Kick in, and get your memberships done with us.`,
        plans: [
            {
                name: 'Individual',
                price: {
                    monthly: 2500,
                    quarterly: 6750,
                    halfYearly: 15000,
                    annual: 30000
                }
            },
            {
                name: 'Couple',
                price: {
                    monthly: 15194.30,
                    quarterly: 37985.75,
                    halfYearly: 76047.47,
                    annual: 136748.70
                }
            },
            {
                name: 'Family',
                price: {
                    monthly: 15194.30,
                    quarterly: 37985.75,
                    halfYearly: 84404.34,
                    annual: 136748.70
                }
            }
        ]
    },
    {
        name: 'Gym',
        hourly: false,
        description: 'Worried from situations prevailed. Want to withstand life’s heavy force upon you? Push them all away, just like you do weights!',
        image: 'gym.jpg',
        imageFormat: 'jpg',
        content: `The culture of exercising in India is from the very ancient times but, has been extinct, and re-emerging after quite some time in a much-modernized manner as “GYM”. Around the world, people are demanding new and varying training styles and personalized instruction to reach their Health and Fitness goals. The Fitness industry is being one of the most successful industries. The penetration of the fitness industry has made a revolution in daily lifestyles and a whopping interest to invest in rejuvenating their health.

            In this world, the very best and a long lasting outfit someone can own can be their own “BODY”. Every one of us dreams of being ripped, build muscle, lose fat and maintain the body. Believe in your dream, we help your dream work with our top-notch equipment and trainers that tailor the best program that suit your profile

            Come, Join us! We understand your zeal for being fit. We understand what it means to be fit. We understand the love for your body and help you with your fitness goals starting from fat loss, muscle gain, packs, ripped muscle, being huge, attain flexibility, improve body posture, improve height and many more. 

            Having a good gym with flawless equipment is a very primary rule while on an exercise. As using uncertified & low standard equipment off late could lead to many problems by disturbing the structure of the muscle, such as an imbalance in twin muscles, reduce bone density, a perversion in the body posture, etc.

            Hence, we are very keen on choosing the right and much safe equipment for all our members. We have equipment starting from treadmills, cycles, cross trainers, weights, barbells, battle ropes, weight balls, kettle balls, skipping ropes yoga mats, HIIT workout equipment and many more.

            You feel sore? Does your muscle feel stiff after an intense workout session? If it’s yes, our gym has a solution for this. We are equipped with top-class steam bath facilities here. The steam helps to relax the stiff joints and muscles after workouts and can help with the recovery process. This session apart from helping the muscles also help in maintaining your skin health by cleansing your skin and removing toxins.

            Still, don’t find enough motivation? Come visit us, that is what you find it over here!`,
        plans: [
            {
                name: 'Individual',
                price: {
                    monthly: 2500,
                    quarterly: 6750,
                    halfYearly: 15000,
                    annual: 30000
                }
            },
            {
                name: 'Couple',
                price: {
                    monthly: 15194.30,
                    quarterly: 37985.75,
                    halfYearly: 76047.47,
                    annual: 136748.70
                }
            },
            {
                name: 'Family',
                price: {
                    monthly: 15194.30,
                    quarterly: 37985.75,
                    halfYearly: 84404.34,
                    annual: 136748.70
                }
            }
        ]
    },
    {
        name: 'Cricket',
        hourly: true,
        description: 'Whether an innings of cricket or in real life, one should stay aware, strong and quick to face the tough yorkers on to you with a passion. So, exactly this is why we are here!',
        image: 'cricket.jpg',
        imageFormat: 'jpg',
        content: `Do you think we bleed red? Then it’s your illusion, we bleed “BLUE”.  The love for cricket in the Indian masses is utmost. Whether it starts from Bollywood blockbusters like “Lagaan”, whether it might be the spirit of introducing helicopter shots to Yorkers & other magnificent drives, whether this land posses the spirit of cricket in every inch-by-inch of this soil. The game was never an ordinary one, rather it is considered as a religion and the practice of the religion is with extreme passion, love, and hard work. Do you know how does a young Indian heart sound? Is that LUB DUB? No. “DE GHUMA KE”, an anthem in the heart which sounds in a loop & echo.

            The streets of India was once very famous with kids playing cricket all the times and also considered to have more “Gully cricketers”, rather than trees on a street. But the gully cricketers are being extinct these days. It is probably due to the chaos with the residents & neighbors around. But, do not worry. We bring back your love and spirits for the sport as usual and even much more by introducing a professional arena, world-class infrastructure and top-notch facilities that the sport demands and master your cricket goals definitely.

            We are done with our innings with the presentation, let’s get the other innings started by bringing up your footfall, tightening shoelaces, pad-up, and give it a shot!`,
        plans: [
            {
                name: 'Individual',
                price: {
                    monthly: 1200,
                    quarterly: 7597.15,
                    halfYearly: 75971.50,
                    annual: 136748.70
                }
            },
            {
                name: 'Couple',
                price: {
                    monthly: 15194.30,
                    quarterly: 37985.75,
                    halfYearly: 76047.47,
                    annual: 136748.70
                }
            },
            {
                name: 'Family',
                price: {
                    monthly: 15194.30,
                    quarterly: 37985.75,
                    halfYearly: 84404.34,
                    annual: 136748.70
                }
            }
        ]
    },
    {
        name: 'Yoga',
        hourly: false,
        description: '',
        image: '',
        imageFormat: 'jpg',
        content: ``,
        plans: [
            {
                name: 'Individual',
                price: {
                    monthly: 2000,
                    quarterly: 5400,
                    halfYearly: 12000,
                    annual: 24000
                }
            },
            {
                name: 'Couple',
                price: {
                    monthly: 15194.30,
                    quarterly: 37985.75,
                    halfYearly: 76047.47,
                    annual: 136748.70
                }
            },
            {
                name: 'Family',
                price: {
                    monthly: 15194.30,
                    quarterly: 37985.75,
                    halfYearly: 84404.34,
                    annual: 136748.70
                }
            }
        ]
    },
    {
        name: 'Zumba',
        hourly: false,
        description: '',
        image: '',
        imageFormat: 'jpg',
        content: ``,
        plans: [
            {
                name: 'Individual',
                price: {
                    monthly: 2500,
                    quarterly: 6750,
                    halfYearly: 15000,
                    annual: 30000
                }
            },
            {
                name: 'Couple',
                price: {
                    monthly: 15194.30,
                    quarterly: 37985.75,
                    halfYearly: 76047.47,
                    annual: 136748.70
                }
            },
            {
                name: 'Family',
                price: {
                    monthly: 15194.30,
                    quarterly: 37985.75,
                    halfYearly: 84404.34,
                    annual: 136748.70
                }
            }
        ]
    },
    {
        name: 'Combo \n(Gym, Yoga, Zumba)',
        hourly: false,
        description: '',
        image: '',
        imageFormat: 'jpg',
        content: ``,
        plans: [
            {
                name: 'Individual',
                price: {
                    monthly: 4000,
                    quarterly: 10800,
                    halfYearly: 24000,
                    annual: 48000
                }
            },
            {
                name: 'Couple',
                price: {
                    monthly: 15194.30,
                    quarterly: 37985.75,
                    halfYearly: 76047.47,
                    annual: 136748.70
                }
            },
            {
                name: 'Family',
                price: {
                    monthly: 15194.30,
                    quarterly: 37985.75,
                    halfYearly: 84404.34,
                    annual: 136748.70
                }
            }
        ]
    },
];

export const fullClub = {
    name: 'Full Club Membership - Single, Couple, Family (upto 4)',
    plans: [
        {
            name: 'Single',
            price: {
                monthly: 5999,
                quarterly: 16197,
                halfYearly: 35994,
                annual: 71988
            }
        },
        {
            name: 'Couple',
            price: {
                monthly: 8499,
                quarterly: 22947,
                halfYearly: 50994,
                annual: 101988
            }
        },
        {
            name: 'Family \n(upto 4)',
            price: {
                monthly: 11999,
                quarterly: 32397,
                halfYearly: 71994,
                annual: 143988
            }
        }
    ]
}

export const memberSports = {
    name: 'Direct Slot Booking',
    games: [
        {
            name: 'Futsal',
            price: 900
        },
        {
            name: 'Cricket',
            price: 900
        }
    ]
}

export default membership;